<template>
  <!--主数据管理-->
  <div id="mainDateManager">
    <div class="allMenuHead">
      <!-- <div :style="{'left': step ? '25px' : '145px'}"  class="moveLine p_a"></div>-->
      <div v-if="$childMenu.indexOf('分组管理') >= 0" :class="step === 1 ? 'active' : ''" @click="toUrl('mainDateList', 1)" class="d_i headTab p_r">分组管理<div class="p_a"></div></div>
      <div v-if="$childMenu.indexOf('推送管理') >= 0" :class="step === 2 ? 'active' : ''" @click="toUrl('ContentRelease', 2)" class="d_i headTab p_r">推送管理<div class="p_a"></div></div>
      <!-- <div v-if="appowner.roles.indexOf('AppOwner') >= 0 || appowner.roles.indexOf('ContentOwner') >= 0 || appowner.roles.indexOf('ContentEditor') >= 0 || isSystemAdmin === 'true' " :class="!step ? 'active' : ''" @click="toUrl('/categoryList', 2)"  class="d_i headTab p_r">内容类别管理<div class="p_a"></div></div> -->
      <div v-if="$childMenu.indexOf('文章报告') >= 0" :class="step === 3 ? 'active' : ''" @click="toUrl('articleReports', 3)" class="d_i headTab p_r">文章报告<div class="p_a"></div></div>
    </div>
    <div class="allHeaderRouter">
      <transition name="fadeLeft">
        <router-view></router-view>
      </transition>
    </div>
  </div>
</template>

<script>
let Time
export default {
  name: 'mainDateManager',
  data () {
    return {
      step: 1,
      isSystemAdmin: window.sessionStorage.getItem('isSystemAdmin'),
      appowner: JSON.parse(window.sessionStorage.getItem('nowApp'))
    }
  },
  created () {
    Time = setInterval(p => {
      if (window.location.href.indexOf('mainDateList') >= 0) {
        this.step = 1
      }
      if (window.location.href.indexOf('ContentRelease') >= 0) {
        this.step = 2
      }
      if (window.location.href.indexOf('articleReports') >= 0) {
        this.step = 3
      }
    }, 100)
  },
  destroyed () {
    clearInterval(Time)
  },
  methods: {
    toUrl (url, num) {
      // if (num === 1) {
      //   this.step = true
      // } else {
      //   this.step = false
      // }
      this.step = num
      this.$router.push({
        name: url
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/pages/mainDateManager/mainDateManager.vue